module.exports = __webpack_public_path__ + "static/discarded-&-served_ceramic-sculpture-&-mixed-media_4x15x10in-19b6b327ae9c0332f18d96236acb4ed8.jpg";